/**
 * Apparition discrète des blocs au défilement (fondu + léger glissement).
 *  - data-reveal            : l'élément apparaît quand il entre dans l'écran
 *  - data-reveal="left"     : idem, avec un glissement latéral au lieu du vertical
 *  - data-reveal-stagger    : les enfants directs apparaissent l'un après l'autre
 *  - style="--reveal-delay: .15s" : retard personnalisé
 * Les styles sont dans styles/base/_reveal.scss (actifs seulement si <html class="js">).
 */
const STEP = 0.09; // décalage entre deux éléments d'un groupe, en secondes

export function initReveal() {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-reveal-stagger]').forEach((group) => {
    [...group.children].forEach((child, i) => {
      child.setAttribute('data-reveal', child.getAttribute('data-reveal') || '');
      child.style.setProperty('--reveal-delay', `${(i * STEP).toFixed(2)}s`);
    });
  });

  const items = document.querySelectorAll('[data-reveal]');

  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' },
  );

  items.forEach((el) => observer.observe(el));
}
